import { useMemo } from "react";

import { CommandGroup } from "~/core/ui/Command";
import CalendarClockIcon from "~/core/ui/CustomIcons/CalendarClockIcon";
import If from "~/core/ui/If";

import { useNextMeeting } from "~/components/NavbarQuickMeeting/hooks/useNextMeeting";
import OctoTag from "~/components/OctoTag";

import { useClientGmailConnectionStatus } from "~/lib/gmail/hooks";

import { NEXT_MEETING_COMMAND_ID } from "../../constants/common";
import { useGlobalCommandbarStore } from "../../store";
import {
  CommandbarFilterTabType,
  CommandbarItemType,
} from "../../types/common";

import CommandbarItem from "./CommandbarItem";

export default function MeetingSection() {
  const { nextMeeting, nextMeetingStartsIn } = useNextMeeting();
  const activeFilterTab = useGlobalCommandbarStore(st => st.activeFilterTab);
  const searchQuery = useGlobalCommandbarStore(st => st.searchQuery);
  const { data: gmailConnectionStatus } = useClientGmailConnectionStatus();

  const shouldShowMeetingSection = useMemo(() => {
    const isApplicableFilterTab =
      activeFilterTab === CommandbarFilterTabType.COMMAND ||
      activeFilterTab === CommandbarFilterTabType.ALL;

    const matchedSearchQuery = (nextMeeting?.title + " meeting")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    return isApplicableFilterTab && matchedSearchQuery;
  }, [activeFilterTab, nextMeeting, searchQuery]);

  const preparedMeetingLink = useMemo(() => {
    if (!gmailConnectionStatus?.[0]?.email) return nextMeeting?.meeting_link;

    return (
      nextMeeting?.meeting_link +
      `?authuser=${gmailConnectionStatus?.[0]?.email}`
    );
  }, [nextMeeting?.meeting_link, gmailConnectionStatus]);

  if (!shouldShowMeetingSection || !nextMeeting) return null;

  return (
    <CommandGroup
      heading="Meeting"
      className="[&_[cmdk-group-heading]]:pt-0 [&_[cmdk-group-heading]]:font-normal"
    >
      <CommandbarItem
        command={{
          id: NEXT_MEETING_COMMAND_ID,
          label: nextMeeting.title,
          type: CommandbarItemType.COMMAND,
          ctaLabel: "Join",
        }}
        onClick={() => {
          window.open(preparedMeetingLink, "_blank");
        }}
      >
        <div className="w-full flex items-center gap-2 justify-between">
          <div className="flex items-center gap-2">
            <CalendarClockIcon className="size-5" />
            <div className="flex items-center gap-2">
              <p>{nextMeeting.title}</p>
              <If condition={nextMeetingStartsIn}>
                <OctoTag className="bg-warning-lighter text-warning-dark">
                  {nextMeetingStartsIn}
                </OctoTag>
              </If>
            </div>
          </div>
          <p>Command</p>
        </div>
      </CommandbarItem>
    </CommandGroup>
  );
}
